// Featured tip card navigation
export function initFeaturedTips() {
    // Find all featured tips containers on the page
    const featuredTipsContainers = document.querySelectorAll('[data-section="featured-tips"]');

    featuredTipsContainers.forEach((container) => {
        initSingleFeaturedTip(container as HTMLElement);
    });
}

function initSingleFeaturedTip(container: HTMLElement) {
    const primaryCard = container.querySelector<HTMLElement>('.primary-tip-card');
    const nextCardTemplate = container.querySelector<HTMLElement>('.next-tip-template');
    const lastCardTemplate = container.querySelector<HTMLElement>('.last-featured-tip-card');
    const allTipsContainer = container.querySelector('.all-tips');

    if (!primaryCard || !nextCardTemplate || !allTipsContainer) return;

    const allTips = Array.from(allTipsContainer.querySelectorAll('.tip-data'));
    let currentIndex = 0;

    // Get navigation buttons scoped to this container
    const primaryNavButtons = primaryCard.querySelectorAll('.btn-icon-tip-card');
    const lastCardPrevButton = lastCardTemplate?.querySelector('.btn-icon-tip-card.prev');

    // Primary card navigation
    primaryNavButtons.forEach((button, buttonIndex) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();

            // First button is prev (index 0), second is next (index 1)
            if (buttonIndex === 1) {
                // Next: increment or show last card if at the end
                if (currentIndex < allTips.length - 1) {
                    currentIndex++;
                    updateTipCards(currentIndex);
                    updateButtonStates(currentIndex);
                } else if (lastCardTemplate) {
                    // Show last card
                    showLastCard();
                }
            } else {
                // Prev: only decrement if not at the start
                if (currentIndex > 0) {
                    currentIndex--;
                    updateTipCards(currentIndex);
                    updateButtonStates(currentIndex);
                }
            }
        });
    });

    // Last card prev button navigation
    if (lastCardPrevButton) {
        lastCardPrevButton.addEventListener('click', (e) => {
            e.preventDefault();
            hideLastCard();
        });
    }

    function showLastCard() {
        if (!lastCardTemplate || !primaryCard || !nextCardTemplate) return;

        primaryCard.classList.add('hidden');
        nextCardTemplate.classList.add('hidden');
        lastCardTemplate.classList.remove('hidden');
    }

    function hideLastCard() {
        if (!lastCardTemplate || !primaryCard) return;

        lastCardTemplate.classList.add('hidden');
        primaryCard.classList.remove('hidden');

        // Show the last tip content
        currentIndex = allTips.length - 1;
        updateTipCards(currentIndex);
        updateButtonStates(currentIndex);
    }

    function updateButtonStates(index: number) {
        const prevButton = primaryNavButtons[0] as HTMLElement;
        const nextButton = primaryNavButtons[1] as HTMLElement;

        // Disable prev button at start
        if (index === 0) {
            prevButton.classList.add('opacity-50', 'cursor-not-allowed', 'pointer-events-none');
        } else {
            prevButton.classList.remove('opacity-50', 'cursor-not-allowed', 'pointer-events-none');
        }

        // Next button is never disabled now (goes to last card)
        nextButton.classList.remove('opacity-50', 'cursor-not-allowed', 'pointer-events-none');
    }

    // Initialize button states
    updateButtonStates(currentIndex);

    function updateTipCards(index: number) {
        const currentTip = allTips[index];
        const nextIndex = index + 1;
        const nextTip = nextIndex < allTips.length ? allTips[nextIndex] : null;

        if (!currentTip || !primaryCard) return;

        // Update primary card content
        const currentTitle = currentTip.querySelector('.title');
        const currentDescription = currentTip.querySelector('.description');

        const primaryTitle = primaryCard.querySelector('.h3');
        const primaryDescription = primaryCard.querySelector('.h3 + div'); // Select the div after .h3
        const tipIndexElement = primaryCard.querySelector('#tip-index');

        if (currentTitle && primaryTitle) {
            primaryTitle.innerHTML = currentTitle.innerHTML;
        }
        if (currentDescription && primaryDescription) {
            primaryDescription.innerHTML = currentDescription.innerHTML;
        }
        if (tipIndexElement) {
            tipIndexElement.textContent = (index + 1).toString();
        }

        // Update primary card data-index
        primaryCard.setAttribute('data-index', index.toString());

        // Update next card - show last card when at the last tip
        if (index === allTips.length - 1 && lastCardTemplate && nextCardTemplate) {
            // Show the last card template in the next card position
            const lastCardTitle = lastCardTemplate.querySelector('.title');
            const lastCardDescription = lastCardTemplate.querySelector('.description');

            const nextTemplateTitle = nextCardTemplate.querySelector('.title');
            const nextTemplateDescription = nextCardTemplate.querySelector('.description');

            if (lastCardTitle && nextTemplateTitle) {
                nextTemplateTitle.innerHTML = lastCardTitle.innerHTML;
            }
            if (lastCardDescription && nextTemplateDescription) {
                nextTemplateDescription.innerHTML = lastCardDescription.innerHTML;
            }

            nextCardTemplate.classList.remove('hidden');
        } else if (nextTip && nextCardTemplate) {
            const nextTitle = nextTip.querySelector('.title');
            const nextDescription = nextTip.querySelector('.description');

            const nextTemplateTitle = nextCardTemplate.querySelector('.title');
            const nextTemplateDescription = nextCardTemplate.querySelector('.description');

            if (nextTitle && nextTemplateTitle) {
                nextTemplateTitle.innerHTML = nextTitle.innerHTML;
            }
            if (nextDescription && nextTemplateDescription) {
                nextTemplateDescription.innerHTML = nextDescription.innerHTML;
            }

            nextCardTemplate.setAttribute('data-index', nextIndex.toString());
            nextCardTemplate.classList.remove('hidden');
        } else if (nextCardTemplate) {
            // Hide next card if we're at the end and no last card
            nextCardTemplate.classList.add('hidden');
        }
    }
}
